import React, { FC } from 'react';
import { useParams } from 'react-router';

import { IncidentDetails } from './IncidentDetails';
import IncidentsList from './IncidentsList';

const Incidents: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();
  return id ? <IncidentDetails /> : <IncidentsList />;
};

export default Incidents;
